(($) => {
  /**
   * Provides a generic way to redirect the user upon logging in. Clicking
   * an element with [data-login-redirect] stores that attribute's value
   * (i.e. the URL to redirect to) OR the current page URL (if the attribute
   * exists but has no value) in localStorage, which is then used to redirect
   * the logged-in user from the Account template (which is the default
   * redirect from the login form).
   */

  const localStorageKey = 'loginRedirect';
  const template = $('body').data('template');

  /**
   * Perform the redirect from the Account template OUTSIDE
   * OF jQuery's ready callback (which is slightly faster).
   */
  if (template === 'customers-account') (() => {
    const redirect = localStorage.getItem(localStorageKey);

    if (redirect) {
      localStorage.removeItem(localStorageKey);

      window.location = redirect;
    }
  })();

  $(() => {
    $('[data-login-redirect]').on('click', (e) => {
      let redirect = e.target.dataset.loginRedirect;

      if (!redirect) redirect = window.location.href;

      localStorage.setItem(localStorageKey, redirect);
    });
  });
})(jQuery);
